import React, { useState } from 'react'
import styled from 'styled-components'

import { formatText, TextFormatType } from '../../utils'

type FormattedTextProps = {
    text: string
    invertSpoiler?: boolean
    className?: string
}


const insertNewLines = (text: string) => {
    const lines = text.split("\n")

    const arrJoin: <T>(arr: T[]) => (T | JSX.Element)[] = (arr) => {
        if (!arr || arr.length === 1) {
            return arr
        }

        return [arr[0], <br />, ...arrJoin(arr.slice(1))]
    }

    return arrJoin(lines)
}

const FormattedText: React.FunctionComponent<FormattedTextProps> = ({ text, invertSpoiler, className }) => {
    const formatted = formatText(text)

    return (
        <span className={className}>
            {
                formatted.map((f, i) => {
                    switch (f.type) {
                        case TextFormatType.Bold:
                            return <Bold key={i}>{insertNewLines(f.text)}</Bold>
                        case TextFormatType.Italic:
                            return <Italic key={i}>{insertNewLines(f.text)}</Italic>
                        case TextFormatType.Spoiler:
                            return <SpolerText key={i} text={f.text} invert={invertSpoiler}/>
                            case TextFormatType.Link:
                                return <ExternalLink 
                                    key={i} 
                                    href={(f.data as {url: string}).url} 
                                    target="_blank"
                                    invert={invertSpoiler}
                                >
                                        {f.text}
                                </ExternalLink>
                        default:
                            return insertNewLines(f.text)
                    }
                })
            }
        </span>
    )
}

const SpolerText: React.FunctionComponent<{text: string, invert?: boolean}> = ({ text, invert }) => {
    const [hidden, setHidden] = useState(true)

    const result = insertNewLines(text || "")

    return (
        <Spolier hide={hidden} onClick={() => setHidden(!hidden)} invert={invert}>
            { result }
        </Spolier>
    )
}


const Bold = styled.span`
    font-weight: 700;
`

const Italic = styled.span`
    font-style: italic;
`

const Spolier = styled.span<{hide: boolean, invert?: boolean}>`
    ${p => p.hide ? `
        background: ${p.invert ? 'white' : 'black' };
        color: ${p.invert ? 'white' : 'black' };
    ` : ''}
    cursor: pointer;
`

export const ExternalLink = styled.a<{ invert?: boolean}>`
    &, &:active, &:visited, &:focus {
        text-decoration: none;
        color: ${p => p.invert ? p.theme.colors.bg : p.theme.colors.accent};
        border-bottom: 1px solid ${p => p.invert ? p.theme.colors.bg : p.theme.colors.accent};
    }
    cursor: pointer;
`


export default FormattedText